import {
  ParentBlockSelectField,
  getSourceBlockNameHelperText,
} from '../../../ConfigFields/SelectField';

export function CreateEncounterFormFields() {
  return (
    <ParentBlockSelectField
      fieldName="config.payload"
      label="Encounter"
      helperText={getSourceBlockNameHelperText('encounter')}
    />
  );
}
